import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../auth';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  if (isAuthenticated()) {
    return children;
  }

  return <Navigate to="/admin/login" state={{ from: location }} replace />;
};

export default ProtectedRoute;
